/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function onTabClick(event) {  
  let activeTabs = document.querySelectorAll('.active');  

  // deactivate existing active tab and panel 
  activeTabs.forEach(function(tab) {
    tab.classList.remove('active');;
  });
  
  // activate new tab and panel
  this.classList.add('active');
  document.getElementById(this.id.split('trigger-')[1]).classList.add('active');
}


let trigger = document.querySelectorAll('.tab-header');

trigger.forEach(function(el) {
  el.addEventListener('click', onTabClick, false);
});
